module.exports = __webpack_public_path__ + "img/GAME_OILPAINT1.187ddd8b.jpg";